import React from 'react';

import { VOID_FUNCTION } from 'constants/index';
import { CrossMIcon } from 'assets/icons';

import * as S from './DesktopBanner.styles';

export const DesktopBanner = (props) => {
  const {
    className,
    title = '',
    description = '',
    onlyDescription = '',
    buttonText = '',
    Img = null,
    imgPosition = 'left',
    theme = '1',
    size = 'm',
    onClick = VOID_FUNCTION,
    dataTest = '',
  } = props;

  return (
    <S.Container
      className={className}
      theme={theme}
      size={size}
      data-test={`${dataTest}-container`}
    >
      {Img && imgPosition === 'left' && <S.LeftImgWrapper>{Img}</S.LeftImgWrapper>}

      <S.TextContainer>
        {title && <S.Title>{title}</S.Title>}
        {description && <S.Description>{description}</S.Description>}
        {!title && !description && onlyDescription && (
          <S.OnlyDescription>{onlyDescription}</S.OnlyDescription>
        )}
      </S.TextContainer>

      {Img && imgPosition === 'right' && <S.RightImgWrapper>{Img}</S.RightImgWrapper>}

      {buttonText ? (
        <S.StyledButton
          buttonTheme={theme}
          imgPosition={imgPosition}
          onClick={onClick}
          dataTest={`${dataTest}-TextButton`}
        >
          {buttonText}
        </S.StyledButton>
      ) : (
        <S.StyledButton
          buttonTheme={theme}
          Icon={CrossMIcon}
          imgPosition={imgPosition}
          onClick={onClick}
          dataTest={`${dataTest}-CloseCrossButton`}
        />
      )}
    </S.Container>
  );
};
